import React from "react";
import thumbDefault from "../../assets/images/thumbdefault.jpeg";
import { formatVideoTime } from "../../util/course";
import PlayButton from "../PlayButton";
import ProgressBar from "../ProgressBar";
import * as S from "./styles.js";

const VideoContainer = ({ hasAccess = false, content, playVideo }) => {
  return (
    <S.Wrapper>
      <div>
        <S.Image
          src={content.images.thumbUrl ? content.images.thumbUrl : thumbDefault}
          alt="imagem da aula"
        />
        <ProgressBar progress={content.progressInPercentage} />
      </div>

      <S.ContentInfo>
        <S.Title>{content.title}</S.Title>
        <S.Duration>
          {typeof content.duration === "number" &&
            formatVideoTime(content.duration)}
          {content.isFinished && (
            <S.WatchedTag>
              <span>Visto</span>
            </S.WatchedTag>
          )}
        </S.Duration>
      </S.ContentInfo>

      {hasAccess ? (
        <S.PlayButtonContainer>
          <PlayButton
            onClick={() => playVideo(content.slug)}
            className={`content-video-play-button_${content.slug}`}
          />
        </S.PlayButtonContainer>
      ) : (
        <S.LockedButtonContainer>
          <i className="fas fa-lock-alt" />
        </S.LockedButtonContainer>
      )}
    </S.Wrapper>
  );
};

export default VideoContainer;
